export const VISUAL_MODEL_DATA_TYPE = "http://dataspecer.com/resources/local/visual-model";
export function isModelVisualInformation(what) {
    return what.type.includes(VISUAL_MODEL_DATA_TYPE);
}
export function createVisualModelData(value) {
    return { ...value, type: [VISUAL_MODEL_DATA_TYPE] };
}
//# sourceMappingURL=visual-model-data.js.map